import React, { useEffect } from 'react';

import { Controller } from 'react-hook-form';

import { FiltersStatus } from 'components/common/GlobalFiltersInPage/GlobalFiltersInPage';
import classes from 'components/common/GlobalFiltersInPage/GlobalFiltersInPage.module.scss';
import {
    ActivityType,
    activityTypeOptions,
} from 'components/common/GlobalFiltersInPage/components/ActivityTypeFilter/activityTypeFilter.consts';
import { signalSingleFilterIsReady } from 'components/common/GlobalFiltersInPage/hooks/useSubscribersFiltersReady';

import { Select } from 'components/DesignSystem/Select';

interface Props {
    methods?: any;
    name: string;
    filtersStatusRef?: React.MutableRefObject<FiltersStatus>;
    handleFilters?: () => void;
    className?: string;
    value?: string;
}

export const ActivityTypeFilter = ({ name, methods, filtersStatusRef, handleFilters, className, value }: Props) => {
    useEffect(() => {
        if (!filtersStatusRef?.current || filtersStatusRef?.current[name]?.isReady) {
            return;
        }
        if (value) {
            methods?.setValue(name, value);
        }
        signalSingleFilterIsReady({ filterId: name, isReady: true });
    }, [value, filtersStatusRef, name, methods]);

    const handleChange = (option: ISelectOption<string> | null) => {
        methods?.setValue(name, option ? option.value : null);
        handleFilters && handleFilters();
    };

    const handleValue = (filterValue) => {
        if (!filterValue) {
            return null;
        }
        return activityTypeOptions.find((item) => item.value === value) || null;
    };

    return (
        <div className={`${classes.selectWrapper} ${className ?? ''}`}>
            <div className={classes.activityCodesSelectWrapper}>
                <Controller
                    render={({ field }) => (
                        <Select<ISelectOption<ActivityType>>
                            {...field}
                            options={activityTypeOptions}
                            id={'global-filter-component-activity-type'}
                            onChange={handleChange}
                            value={handleValue(field.value)}
                            label={'Activity Type'}
                        />
                    )}
                    name={name}
                    control={methods?.control}
                />
            </div>
        </div>
    );
};
